import React from "react";
import { berlinDistricts, surroundingTowns } from "../data/serviceArea";
import "./ServiceArea.css";

const ServiceArea = () => (
  <section className="service-area" aria-labelledby="einsatzgebiet-title">
    <h2 id="einsatzgebiet-title">Einsatzgebiet: Berlin und Umgebung</h2>
    <p className="service-area-lead">
      Von unserem Standort in Berlin-Tempelhof (12107) übernehmen wir
      Unterhaltsreinigung, Glas- und Fassadenreinigung, Baureinigung,
      Grundreinigung und Teppichreinigung in allen Berliner Bezirken und im
      nahen Umland.
    </p>
    <div className="service-area-grid">
      <div className="service-area-box">
        <h3>Berlin</h3>
        <ul>
          {berlinDistricts.map((place) => (
            <li key={place}>{place}</li>
          ))}
        </ul>
      </div>
      <div className="service-area-box">
        <h3>Berliner Umland</h3>
        <ul>
          {surroundingTowns.map((place) => (
            <li key={place}>{place}</li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default ServiceArea;
